import { ROLES } from './../menu/items';
import { AutenticacionService } from 'src/app/servicios/autenticacion.service';
import { Pago, PagosService, ESTADOS_PAGO } from './../../../servicios/pagos.service';
import { ResultadoServicio } from './../../../servicios/lugares.service';
import { TIPOS_VISITAS, Visitante, VisitantesService, VisitantesUnidad } from './../../../servicios/visitantes.service';
import { Component, AfterViewInit, Input } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { merge, of as observableOf } from 'rxjs';
import { catchError, debounceTime, filter, map } from 'rxjs/operators';
import { Lugar, LugaresService } from 'src/app/servicios/lugares.service';
import * as moment from 'moment';

enum TIPOS_PAGOS {
  ACTIVOS = 1,
  HISTORIAL = 0
}
@Component({
  selector: 'app-tabla-general',
  templateUrl: './tabla-general.component.html',
  styleUrls: ['./tabla-general.component.scss']
})
export class TablaGeneralComponent implements AfterViewInit {
  
  // Modulo visitantes
  TIPOS_VISITAS = TIPOS_VISITAS;
  tipoVisitas = TIPOS_VISITAS.VISITAS_PROGRAMADAS;

  // Modulo pagos
  TIPOS_PAGOS = TIPOS_PAGOS;
  tipoPagos = TIPOS_PAGOS.ACTIVOS;


  ESTADOS_PAGO = ESTADOS_PAGO;
  @Input() moduloActual: string;
  @Input() displayedColumns: any[] = [];
  data: Lugar[] | Visitante[] = [];
  hide = false;

  cargandoDatos = true;
  isRateLimitReached = false;
  paginaActual = 0;
  ultimaPagina;

  elementosPorPagina = 8;

  constructor(
    private visitantesService: VisitantesService,
    private lugaresService: LugaresService,
    private pagosService: PagosService,
    private router: Router,
    private autenticacionService: AutenticacionService,
  ) { }

  public filtrosForm: FormGroup = new FormGroup({
    palabrasClave: new FormControl(""),
    fechaInicio: new FormControl(moment().set({
      hours: 0,
      minutes: 0,
      seconds: 0
    })),
    fechaFinal: new FormControl(moment().set({
      hours: 23,
      minutes: 0,
      seconds: 0
    }))
  })

  ngOnInit() {
    this.palabrasClaveValueChange();
    this.fechasValueChange();

    if(this.moduloActual === "pagos") {
      this.pagosService.detallePago.subscribe(res => {
        if(!res) {
          this.cargarDatosTabla();
        }
      });
    }
  }

  ngAfterViewInit() {
    this.cargarDatosTabla();
  }
  
  public cargarDatosTabla() {
    switch (this.moduloActual) {
      case "lugares":
        this.cargarDatosApartamentos();
        break;
      case "citofonia":
        this.cargarDatosApartamentos();
        break;
      case "visitantes":
        this.cargarDatosVisitantes();
        break;
      case "pagos":
        this.cargarDatosPagos();
        break;
      default:
        this.cargarDatosApartamentos();
        break;
    }
  }

  public cargarDatosApartamentos() {
    this.cargandoDatos = true;
    this.lugaresService.getLugares(this.paginaActual, this.filtrosForm.get("palabrasClave").value)
      .pipe(catchError(() => observableOf(null)), map(data => {
        this.cargandoDatos = false;
        this.isRateLimitReached = data === null;

        if (data === null) {
          return [];
        }

        return data.data.lugares;
      })).subscribe(data => {
        if(data.length === 0 && this.paginaActual > 0) {
          this.paginaAnterior();
          this.ultimaPagina = this.paginaActual;
        } else {
          this.data = data;
        }
      });
  }

  public cargarDatosVisitantes() {
    this.cargandoDatos = true;
    this.visitantesService.traerVisitantes(
      this.paginaActual,
      this.tipoVisitas,
      this.filtrosForm.get("palabrasClave").value,
      this.filtrosForm.get("fechaInicio").value.format("YYYY-MM-DD"),
      this.filtrosForm.get("fechaInicio").value.format("HH:mm:ss"),
      this.filtrosForm.get("fechaFinal").value.format("YYYY-MM-DD"),
      this.filtrosForm.get("fechaFinal").value.format("HH:mm:ss"),
      )
    .pipe(catchError(() => observableOf(null)), map((res: ResultadoServicio<VisitantesUnidad>) => {
      this.cargandoDatos = false;
      this.isRateLimitReached = res === null;

      if (res === null) {
        return [];
      }

      return res.data.visitantes.map(visitante => {
        // TODO: Revisar que siempre se devuelva
        const dateCheckIn = moment(visitante.date_checkin);
        const hhmmssCheckIn = (visitante.hour_checkin || "").split(":");
        const dateCheckOut = moment(visitante.date_checkin);
        const hhmmssCheckOut = (visitante.hour_checkout || "").split(":");

        dateCheckIn.set("hour", parseInt(hhmmssCheckIn[0]));
        dateCheckIn.set("minute", parseInt(hhmmssCheckIn[1]));

        dateCheckOut.set("hour", parseInt(hhmmssCheckOut[0]));
        dateCheckOut.set("minute", parseInt(hhmmssCheckOut[1]));

        let vehiculo = 'Sin vehiculo';

        if(visitante.type_vehicle && visitante.plate_vehicle) {
          vehiculo = `${visitante.type_vehicle}/${visitante.plate_vehicle}`
        } else if (visitante.type_vehicle) {
          vehiculo = visitante.type_vehicle
        }

        return {
          ...visitante,
          hour_checkin: dateCheckIn.format("DD-MM-YYYY hh:mm a" ),
          hour_checkout: (visitante.hour_checkout !== "00:00:00") ? dateCheckOut.format("DD-MM-YYYY hh:mm a") : dateCheckOut.format("DD-MM-YYYY"),
          vehiculo,
          note: visitante.note ?? "-"
        }
      });
    })).subscribe(data => {
      if(data.length === 0 && this.paginaActual > 0) {
        this.paginaAnterior();
        this.ultimaPagina = this.paginaActual;
      } else {
        this.data = data;
      }
    });
  }

  public cargarDatosPagos() {
    this.cargandoDatos = true;
    this.pagosService.traerPagosUnidad(
      this.paginaActual,
      this.filtrosForm.get("palabrasClave").value,
      this.tipoPagos,
      this.filtrosForm.get("fechaInicio").value.unix(),
      this.filtrosForm.get("fechaFinal").value.unix(),
    )
      .pipe(catchError(() => observableOf(null)), map(data => {
        this.cargandoDatos = false;
        this.isRateLimitReached = data === null;

        if (data === null) {
          return [];
        }

        if(data.data.pagos.length === 0 && this.paginaActual>0) {
          this.paginaActual--;
          return this.data
        }

        return data.data.pagos.map((pago: Pago) => ({
          ...pago,
          user_name: pago.user_name + (pago.user_lastname ?  ` ${pago.user_lastname}` : ""),
          type_charge: pago.type_charge && this.capitalize(pago.type_charge),
          type_payment: pago.type_payment && this.capitalize(pago.type_payment),
          date: moment.unix(pago.date).format("DD-MM-YYYY")
        }));
      })).subscribe(data => {
        if(data.length === 0 && this.paginaActual > 0) {
          this.paginaAnterior();
          this.ultimaPagina = this.paginaActual;
        } else {
          this.data = data;
        }
      });
  }

  public get displayedColumnsNames(): string[] {
    return this.displayedColumns.map(column => column.nombre)
  }

  public editar(id) {
    switch (this.moduloActual) {
      case 'lugares':
        this.router.navigate(['lugares', 'apartamentos', id]);
        break;
      case 'citofonia':
        this.router.navigate(['citofonia', 'apartamentos', id]);
        break;
      case 'visitantes':
        this.router.navigate(['visitantes', id]);
        break;
      default:
        break;
    }
  }

  public palabrasClaveValueChange() {
    this.filtrosForm.get("palabrasClave")
      .valueChanges
      .pipe(
        filter(value => value && value.length > 1 || value === ""),
        debounceTime(1200),
        // distinctUntilChanged()
      )
      .subscribe(() => {
        this.paginaActual = 0;
        this.cargarDatosTabla();
      })
  }

  public quitarPalabrasClave() {
    this.filtrosForm.get("palabrasClave").setValue("");
    this.cargarDatosTabla();
  }

  public fechasValueChange() {
    merge(
      this.filtrosForm.get("fechaInicio").valueChanges,
      this.filtrosForm.get("fechaFinal").valueChanges
    ).subscribe(() => {
      this.paginaActual = 0;
      this.cargarDatosTabla()
    });
    
  }

  public numSequence(n: number): Array<number> {
    return Array(n);
  }

  public actualizarPagina(nuevaPagina: number): void {
    this.cargandoDatos = true;
    this.paginaActual = nuevaPagina;
    this.cargarDatosTabla();
  }

  public mostrarModalVerificarPago(detallePago: Pago): void {
    this.pagosService.cambiarDetallePago(detallePago.id);
  }

  public paginaAnterior() {
    this.cargandoDatos = true;
    this.paginaActual--;
    this.cargarDatosTabla();
  }

  public paginaSiguiente() {
    this.cargandoDatos = true;
    this.paginaActual++;
    this.cargarDatosTabla();
  }

  get usuarioEsCelador() {
    return this.autenticacionService.dataLogin.role === ROLES.CELADOR;
  }

  capitalize(word) {
    const lower = word.toLowerCase();
    return word.charAt(0).toUpperCase() + lower.slice(1);
  }

  // Modulo visitantes

  cambiarTipoVisitas(nuevoTipo) {
    this.paginaActual = 0;
    this.tipoVisitas = nuevoTipo;
    this.cargarDatosVisitantes();
  }

  // Modulo pagos

  cambiarTipoPagos(nuevoTipo) {
    this.paginaActual = 0;
    this.tipoPagos = nuevoTipo;
    this.cargarDatosPagos();
  }

  mostrarModalCargarPagos() {
    this.pagosService.cambiarMostrarModalCargarPagos(true);
  }
}